<template>
  <div
    class="Overlay Overlay-sup"
    data-action="close-modal"
    @click.self="closeModal"
  >
    <div class="ModalBox ModalBox--central ModalBox--20vw Modal--filters sup2">
      <div class="ModalBox-header d-flex justify-content-between align-items-center position-absolute p-3">
        <div class="Tit Tit--modal position-absolute w-100">
          <span v-t="{ path :'users_superadmin_create_commercial_modal_header'}"></span>
        </div>
        <div
          class="Ctrl Ctrl--24 u-pointer"
          data-action="close-modal"
          @click="closeModal"
        >
          <svg
            focusable="false"
            aria-hidden="true"
            aria-label="Close"
          >
            <use xlink:href="#close-icon" />
          </svg>
        </div>
      </div>
      <div class="ModalBox-container position-relative pl-4 pr-4 pt-4 mt-5 pb-3">
        <form
          class="Form"
          id="create-commercial-form"
          @submit.prevent="createCommercial"
          autocomplete="off"
        >
          <div class="row">
            <div class="col-12">
              <div class="input--block input--block--margin input--block--padded">
                <label
                  for=""
                  class="form--label u-required"
                >{{$t('FIRST_NAME').toUpperCase()}}</label>
                <div
                  class="Form-field required"
                  :class="{'Form--field-error': $v.commercial.firstName.$error}"
                >
                  <input
                    type="text"
                    name="first-name"
                    v-model="commercial.firstName"
                    class="Input-text"
                    :placeholder="$t('FIRST_NAME')"
                    @blur="$v.commercial.firstName.$touch()"
                  >
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="input--block input--block--margin input--block--padded">
                <label
                  for=""
                  class="form--label u-required"
                >{{$t('LAST_NAME').toUpperCase()}}</label>
                <div
                  class="Form-field required"
                  :class="{'Form--field-error': $v.commercial.lastName.$error}"
                >
                  <input
                    type="text"
                    name="last-name"
                    v-model="commercial.lastName"
                    class="Input-text"
                    :placeholder="$t('LAST_NAME')"
                    @blur="$v.commercial.lastName.$touch()"
                  >
                </div>
              </div>
            </div>

            <div class="col-12">
              <div class="input--block input--block--margin input--block--padded">
                <label
                  for=""
                  class="form--label u-required"
                >{{$t('EMAIL').toUpperCase()}}</label>
                <div
                  class="Form-field required"
                  :class="{'Form--field-error' : $v.commercial.email.$error}"
                >
                  <input
                    type="text"
                    name="email"
                    @blur="$v.commercial.email.$touch()"
                    v-model="commercial.email"
                    class="Input-text"
                    :placeholder="$t('EMAIL')"
                  >
                </div>
              </div>
            </div>

            <div class="col-12">
              <div class="input--block input--block--margin input--block--padded">
                <label
                  for=""
                  class="form--label u-required"
                >{{$t('PASSWORD').toUpperCase()}}</label>
                <div
                  class="Form-field required"
                  :class="{'Form--field-error' :$v.password.$error}"
                >
                  <input
                    type="password"
                    name="password"
                    autocomplete="new-password"
                    @blur="$v.password.$touch()"
                    v-model="password"
                    maxlength="72"
                    class="Input-text"
                    :placeholder="$t('PASSWORD')"
                  >
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="input--block input--block--margin input--block--padded">
                <label
                  for=""
                  class="form--label u-required"
                >{{$t('REPEAT_PASSWORD').toUpperCase()}}</label>
                <div
                  class="Form-field required"
                  :class="{'Form--field-error' : !$v.repeatPassword.sameAsPassword}"
                >
                  <input
                    type="password"
                    name="repeat-password"
                    v-model="repeatPassword"
                    maxlength="72"
                    @blur="$v.repeatPassword.$touch()"
                    class="Input-text"
                    :placeholder="$t('REPEAT_PASSWORD')"
                  >
                </div>
              </div>
            </div>

          </div>

        </form>
      </div>
      <div class="p-3 d-flex justify-content-center">
        <button
          class="Fuell-Button blue block w-50"
          form="create-commercial-form"
          :disabled="!canBeSubmitted"
          type="submit"
          v-t="{path:'users_superadmin_create_commercial_action_create'}"
        ></button>
      </div>
    </div>
  </div>
</template>
<script>
import _modalHandlerMixin from '@/components/Commons/_mixins/_modalHandlerMixin'
import usersApi from '../../_api'
const { validationMixin } = require('vuelidate')
const { required, email, sameAs, maxLength } = require('vuelidate/lib/validators')

export default {
  name: 'CreateCommercialModal',
  mixins: [_modalHandlerMixin, validationMixin],
  data () {
    return {
      commercial: {
        firstName: '',
        lastName: '',
        email: ''
      },
      password: '',
      repeatPassword: '',
      isCreatingCommercial: false
    }
  },
  methods: {
    async createCommercial () {
      if (this.isCreatingCommercial) return
      try {
        this.isCreatingCommercial = true
        this.commercial.password = this.password
        await usersApi.postCommercial(this.commercial)
        const defaultFilters = {
          'status.statusType.code': ['ACTIVE', 'INVITE_BY_ADMIN', 'INVITE_BY_SUPERADMIN']
        }
        await this.$store.dispatch('UsersStore/setUsersFilters', { filters: defaultFilters })
        this.$store.dispatch('SnackBars/addSuccess', this.$t('users_superadmin_create_commercial_success'))
        this.closeModal()
      } catch (error) {
        this.$store.dispatch('SnackBars/addErrorHandler', { error: error, errorMessage: 'users_superadmin_create_commercial_error' }, { root: true })
      } finally {
        this.isCreatingCommercial = false
      }
    }
  },
  computed: {
    canBeSubmitted () {
      return !this.$v.$invalid
    }
  },
  validations: {
    commercial: {
      firstName: { required },
      lastName: { required },
      email: { required, email }
    },
    password: { required, maxLength: maxLength(72) },
    repeatPassword: { required, sameAsPassword: sameAs('password'), maxLength: maxLength(72) }
  }
}
  </script>
